const App = {};

App.utils = {
  hideLoading() {
    $('body').removeClass('wait');
  },

  thousandSeparator(x) {
    return Math.round(x).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  },

  showLoading($element) {
    $('body').addClass('wait');

    if ($element && !$element.hasClass('js-do-not-show-icon-on-submit') && $element.find('.spinner-border').length === 0) {
      $element.append(
        '<span class="spinner-border spinner-border-sm ml-2"></span>'
      );
    }
  },

  highlight($element) {
    $element.addClass('highlight');

    setTimeout(() => {
      $element.toggleClass('dim highlight');
    }, 15);

    setTimeout(() => $element.removeClass('dim'), 1010);
  }
};


export default App;
